import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4f1b0238"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["title"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "locale-icon",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "22",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M511.359 907.151c221.234 0 395.064-179.098 395.064-395.064S727.325 117.023 511.359 117.023 116.295 296.121 116.295 512.087c0 115.887 42.142 163.293 142.223 194.898 10.537 5.269 15.806 5.269 26.337 10.537 6.89 2.202 18.801 7.71 26.338 10.531 63.212 21.076 94.817 31.607 121.155 63.212 21.068 21.07 36.874 47.412 52.673 73.749 5.269 10.532 9.417 20.798 10.539 26.338 11.093 10.771 11.093 10.771 15.799 15.799z m0 52.675c-73.743 0-26.338-52.675-110.618-136.955C321.73 743.86 63.62 791.265 63.62 512.087c0-247.573 200.166-447.739 447.739-447.739s447.739 200.167 447.739 447.739-200.166 447.739-447.739 447.739z m89.548-131.686c-52.675 0-94.817-42.144-94.817-94.817 0-52.675 42.142-89.55 94.817-89.55s94.819 42.144 94.819 89.55c0 47.411-42.144 94.817-94.819 94.817z m0-52.675c21.068 0 42.138-15.806 42.138-42.142 0-26.338-15.799-36.869-42.138-36.869-26.337 0-42.142 15.799-42.142 36.869 0 21.074 21.074 42.142 42.142 42.142z m42.138-447.739c-31.6 0-52.675-21.074-52.675-52.675 0-31.605 21.074-52.679 52.675-52.679 31.605 0 52.681 21.074 52.681 52.679 0 31.601-21.076 52.675-52.681 52.675zM495.56 285.584c-31.607 0-52.675-21.07-52.675-52.675 0-31.607 21.068-52.675 52.675-52.675 31.605 0 52.673 21.068 52.673 52.675 0 31.605-21.068 52.675-52.673 52.675z m252.839 147.492c-31.605 0-52.673-21.068-52.673-52.675 0-31.605 21.068-52.675 52.673-52.675 31.607 0 52.675 21.07 52.675 52.675 0 31.607-21.068 52.675-52.675 52.675z m-395.064-105.35c-31.605 0-52.673-21.074-52.673-52.675 0-31.605 21.068-52.679 52.673-52.679 31.607 0 52.675 21.074 52.675 52.679 0 31.601-21.069 52.675-52.675 52.675z m0 0",
    fill: "currentColor"
  })
], -1))
const _hoisted_3 = [
  _hoisted_2
]

import { computed, onMounted, onUnmounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import {
  getDashboardNavTheme,
  onDashboardNavThemeChange,
  setDashboardNavTheme,
} from '@/utils/dashboard-nav-theme'
import type { DashboardNavTheme } from '@/utils/dashboard-nav-theme'


export default /*#__PURE__*/_defineComponent({
  __name: 'dashboard-nav-theme-toggle',
  props: {
  size: {
    type: String,
    default: 'small'
  }
},
  setup(__props) {

const props = __props
const btnSize = {
  small: 'btn_tool-small',
  default: 'btn_tool-default'
}[props.size||'small']
const THEME_OPTIONS: { value: DashboardNavTheme; labelKey: string }[] = [
  { value: 'deep', labelKey: 'nav.navThemeDeep' },
  { value: 'sky', labelKey: 'nav.navThemeSky' },
]

const { t } = useI18n()
const navTheme = ref<DashboardNavTheme>(getDashboardNavTheme())

let unsubscribe: (() => void) | undefined

onMounted(() => {
  unsubscribe = onDashboardNavThemeChange((theme) => {
    navTheme.value = theme
  })
})

onUnmounted(() => {
  unsubscribe?.()
})

const themeOptions = computed(() =>
  THEME_OPTIONS.map((opt) => ({
    value: opt.value,
    label: t(opt.labelKey),
  })),
)

const currentLabel = computed(
  () => themeOptions.value.find((o) => o.value === navTheme.value)?.label ?? '',
)

function handleCommand(command: string) {
  if (command === 'sky' || command === 'deep') {
    setDashboardNavTheme(command)
    navTheme.value = command
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createBlock(_component_el_dropdown, {
    class: "locale-dropdown",
    "popper-class": "locale-dropdown-popper",
    size: "small",
    trigger: "click",
    onCommand: handleCommand
  }, {
    dropdown: _withCtx(() => [
      _createVNode(_component_el_dropdown_menu, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(themeOptions.value, (opt) => {
            return (_openBlock(), _createBlock(_component_el_dropdown_item, {
              key: opt.value,
              command: opt.value,
              class: _normalizeClass({ 'is-active': navTheme.value === opt.value })
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(opt.label), 1)
              ]),
              _: 2
            }, 1032, ["command", "class"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("span", {
        class: _normalizeClass(["locale-trigger btn_tool", _unref(btnSize)]),
        title: currentLabel.value
      }, _hoisted_3, 10, _hoisted_1)
    ]),
    _: 1
  }))
}
}

})